import React, { useCallback, useContext } from 'react';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import ModalSentErrorWithInfo from './ModalSentErrorWithInfo/ModalSentErrorWithInfo';
import classNames from 'classnames';
import { CreateDishContext, ICreateDishContext } from '../../createDishState/createDishContext';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const {
		resetFields,
		changeTypeOfModalWindow,
		showErrorModalWithInfo,
		errorResponseData,
		typeOfModalWindow,
		fetchedRestaurants,
		fetchedSuggestedDishes,
		fetchedAdditionalDishes,
		fetchedDishModifications,
	} = useContext<ICreateDishContext>(CreateDishContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow || errorResponseData });

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	const handleCloseModalWithInfo = useCallback(() => {
		showErrorModalWithInfo(null);
	}, []);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={resetFields}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={resetFields}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
				visibleTime={500}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'defaultTranslationIsEmpty'}
				description="errorDefaultTranslation"
			/>
			<ModalSentErrorWithInfo
				onConsentEvent={handleCloseModalWithInfo}
				isVisible={!!errorResponseData}
				errorResponseData={errorResponseData}
				fetchedRestaurants={fetchedRestaurants}
				fetchedDishModifications={fetchedDishModifications}
				fetchedAdditionalDishes={fetchedAdditionalDishes}
				fetchedSuggestedDishes={fetchedSuggestedDishes}
			/>
		</div>
	);
};

export default ModalWindows;
